import { GetServerSideProps } from "next";
import { getLocale } from "@/lib/i18n-utils";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import ShareHeader from "@/components/dashboard/share/ShareHeader";
import {
  MainContentLayout,
  MainHeaderLayout,
  MainLayout,
} from "@/styles/MainLayouts";
import axios from "axios";
import { runtimeEnv } from "@/lib/runtime-utils";
import { getSession, useSession } from "next-auth/react";
import { useEffect, useState } from "react";
import ShareTemplate from "@/components/dashboard/share/ShareTemplate";
import { ShareTemplateRoot } from "@/components/dashboard/share/Style";
import { useAppDispatch, useAppSelector } from "@/hooks/redux";
import { StripeModal } from "@/components/editor/stripe/StripeModal";
import dashboardApi from "@/redux/api/dashboardApi";
import { getDashBoardState } from "@/redux/store";
import { dashboardActions } from "@/redux/stores/dashboardStore";
import { getUserInfo } from "@/lib/api-account-utils";
import UnauthorizedTemplate from "@/components/dashboard/share/UnauthorizedTemplate";
import { useCheckDevice } from "@/hooks/useCheckDevice";
import { useRouter } from "next/router";
import { scormApi } from "@/redux/api/scorm/scormApi";
import Head from "next/head";
import { Spin } from "antd";
import { useAndroidBackHandler } from "@/hooks/useAndroidBackHandler";

const TAG = "[SharePage]";

export default function SharePage(props: any) {
  const dispatch = useAppDispatch();
  const session = useSession();

  const { userProjectPermission = "view", projectInfo } = props.pageProps;
  // const { projectInfo } = props.pageProps;

  // const userProjectPermission = null;

  const [projectShareMember, setProjectShareMember] = useState(
    props?.pageProps?.projectShareMember ?? [],
  );
  const [trigger, { data: accountUserInfoData }] =
    dashboardApi.endpoints.getAccountUserInfo.useLazyQuery();
  const { accountUserInfo } = useAppSelector(
    (store) => getDashBoardState(store) ?? false,
  );
  const [isLoading, setIsLoading] = useState(false);

  const { isMobile } = useCheckDevice();

  const router = useRouter();

  // useEffect(() => {
  //   if(props?.pageProps?.errorMessage) {
  //     Modal.error({
  //       title: 'This is an error message',
  //       content: props?.pageProps?.errorMessage,
  //     });
  //     router?.push('/dashboard')
  //   }
  // }, [props?.pageProps?.errorMessage, router])

  useEffect(() => {
    if (accountUserInfo?._id === "") {
      trigger();
      if (accountUserInfoData) {
        dispatch(
          dashboardActions.setAccountUserInfo({
            accountUserInfo: accountUserInfoData,
          }),
        );
      }
    }
  }, [accountUserInfo, dispatch, accountUserInfoData]);

  useEffect(() => {
    const handlePageStart = () =>
      dispatch(dashboardActions.setActionLoading(false));
    router.events.on("routeChangeStart", handlePageStart);

    return () => {
      router.events.off("routeChangeStart", handlePageStart);
    };
  }, [dispatch, router.events, router.pathname]);

  /**
   * 스콤 관련
   */
  const { data: versions } = scormApi.useGetVersionsQuery(
    {
      baseInfoId: projectInfo.baseInfoId,
    },
    {
      skip: !projectInfo?.baseInfoId,
    },
  );

  const { data: publishedScormData, isError: isErrorPublishedScorm } =
    scormApi.useGetPublishedQuery(
      {
        baseInfoId: projectInfo.baseInfoId,
      },
      {
        skip: !projectInfo?.baseInfoId,
      },
    );

  /**
   * 에러인 경우 데이터가 없는 것으로 취급되도록 하기
   */
  const publishedScorm = isErrorPublishedScorm ? undefined : publishedScormData;

  useAndroidBackHandler(() => {
    if (typeof window !== 'undefined' && 'AndroidBridge' in window) {
      setIsLoading(true);
      router.back()
    }
  })

  return (
    <MainLayout>
      <Head>
        <title>{`${projectInfo?.name} - AI STUDIOS`}</title>
        <meta name="description" content="Check out this AI-generated video!" />

        <meta property="og:type" content="video.other" />
        <meta
          property="og:title"
          content={`${projectInfo?.name} - AI STUDIOS`}
        />
        <meta
          property="og:description"
          content="Check out this AI-generated video!"
        />
        <meta property="og:image" content={projectInfo?.thumbnailUrl} />
      </Head>
      <Spin spinning={isLoading} fullscreen={true} size="large" />
      <MainHeaderLayout style={{ height: "auto" }}>
        {/* <AnnounceTopBr isMobile={isMobile}/> */}
        <ShareHeader
          projectShareMember={projectShareMember}
          setProjectShareMember={setProjectShareMember}
          projectInfo={projectInfo}
          userProjectPermission={userProjectPermission || null}
          publishedScorm={publishedScorm}
          versions={versions}
        />
      </MainHeaderLayout>
      {/* <Layout> */}
      <MainContentLayout
        style={{
          display: "flex",
          justifyContent: "center",
          flexDirection: isMobile ? "" : "column",
          paddingTop: "64px",
        }}
      >
        <ShareTemplateRoot>
          {userProjectPermission === "" && <UnauthorizedTemplate />}
          {userProjectPermission !== "" && (
            <ShareTemplate
              isMobile={isMobile}
              projectInfo={projectInfo}
              projectShareMember={projectShareMember}
              userProjectPermission={userProjectPermission}
            />
          )}
        </ShareTemplateRoot>
      </MainContentLayout>
      {/* </Layout> */}
      <StripeModal />
    </MainLayout>
  );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  const locale: string = await getLocale(context);

  const session = await getSession(context);
  const userId = session?.user?.id || "guest";

  const { share_id } = context.params;

  console.log(TAG, `context params`, { share_id });
  const currentUrl = context.req.url;
  console.log("currentUrl: ", currentUrl);
  const {
    data: { data: projectInfo },
  } = await axios.get(
    `${runtimeEnv.BK_STUDIO_URL}/api/dashboard/projectInfo?projectId=${share_id}`
  );

  console.log(TAG, `projectInfo result `, { projectInfo });

  console.log("session?.status: ", session);
  // if (userId === "guest") {
  //   console.log("session 없다");
  //   return {
  //     redirect: {
  //       destination: `/auth/signin?redirect=${currentUrl}`,
  //       permanent: false,
  //     },
  //   };
  // }
  let userProjectPermission = "view";
  let fetchError = "";
  let userInfo = {};
  if (userId !== "guest") {
    try {
      const userData = await getUserInfo(userId);
      userInfo = userData.data;
    } catch (error) {
      console.log("error: ", error);
    }
  }

  // console.log('userInfouserInfo: ', userInfo)

  const planName = userInfo?.plan?.toLocaleLowerCase();
  console.log("planName: ", planName);

  if (
    planName?.includes("team") ||
    planName?.includes("pro") ||
    planName?.includes("enterprise")
  ) {
    console.log("here!!");
    try {
      const { data } = await axios.get(
        `${runtimeEnv.BK_ACCOUNT_URL}/api/studio/v3/workspace/video-share-permission?projectId=${share_id}&userId=${userId}`
      );

      console.log("data!!!!!!: ", data);
      userProjectPermission =
        data?.projectShare?.sharePermission ||
        data?.workspacePermission ||
        "view";

      if (userId === projectInfo?.userId) {
        userProjectPermission = "edit";
      }
      // const {
      //   data: { projectShareMember, errorMessage },
      // } = await axios.post(
      //   `${runtimeEnv.BK_ACCOUNT_URL}/api/studio/v3/workspace/workspace-info`,
      //   {
      //     type: "sharePage",
      //     userId,
      //     projectId: share_id,
      //     projectOwner: projectInfo?.userId,
      //   }
      // );

      // console.log('projectShareMemberprojectShareMemberprojectShareMember: ', projectShareMember)
      // if (errorMessage) {
      //   fetchError = errorMessage;
      // }

      // if (projectInfo?.userId == userId) {
      //   userProjectPermission = "edit";
      // } else {
      //   if (projectShareMember) {
      //     if (projectShareMember?.length > 0) {
      //       const userInfo = projectShareMember.find(
      //         (member) => member.id == userId
      //       );
      //       console.log(TAG, `projectShareMember `, { userInfo }, { userId });

      //       console.log(
      //         "userInfo?.sharePermission: ",
      //         userInfo?.sharePermission
      //       );
      //       userProjectPermission = userInfo?.sharePermission || permission;
      //     }
      //   } else {
      //     userProjectPermission = permission || "view";
      //   }
      // }

      return {
        props: {
          userProjectPermission,
          projectShareMember: [],
          projectInfo: JSON.parse(JSON.stringify(projectInfo)) ?? {},
          errorMessage: fetchError,
          ...(await serverSideTranslations(locale, ["common"])),
        },
      };
    } catch (error) {
      console.log(TAG, `check-project-shared-member error `, {
        error: error?.message,
      });
      return {
        props: {
          userProjectPermission,
          projectShareMember: [],
          projectInfo: JSON.parse(JSON.stringify(projectInfo)) ?? {},
          errorMessage: error?.message,
          ...(await serverSideTranslations(locale, ["common"])),
        },
      };
    }
  } else {
    console.log("herexxxx");
    if (userId === projectInfo?.userId) {
      return {
        props: {
          userProjectPermission: "edit",
          projectShareMember: [
            {
              _id: userInfo?._id,
              id: userInfo?.id || session?.user?.id,
              name: userInfo?.name || session?.user?.name,
              sharePermission: "admin",
              shareType: "user",
              shareName: userInfo?.name || session?.user?.name,
              shareId: userInfo?._id,
              companyPermission: "admin",
              workspacePermission: "admin",
            },
          ],
          projectInfo: JSON.parse(JSON.stringify(projectInfo)) ?? {},
          errorMessage: fetchError,
          ...(await serverSideTranslations(locale, ["common"])),
        },
      };
    }

    // project owner가 아닐경우
    const { data } = await axios.get(
      `${runtimeEnv.BK_ACCOUNT_URL}/api/studio/v3/workspace/video-share-permission?projectId=${share_id}&userId=${userId}`
    );

    console.log("view data: ", data);

    if (projectInfo?.isPublic) {
      return {
        props: {
          userProjectPermission: data?.projectShare?.sharePermission || "view",
          projectShareMember: [],
          projectInfo: JSON.parse(JSON.stringify(projectInfo)) ?? {},
          errorMessage: fetchError,
          ...(await serverSideTranslations(locale, ["common"])),
        },
      };
    } else {
      return {
        props: {
          userProjectPermission: data?.projectShare?.sharePermission || "view",
          projectShareMember: [],
          projectInfo: JSON.parse(JSON.stringify(projectInfo)) ?? {},
          ...(await serverSideTranslations(locale, ["common"])),
        },
      };
    }
  }
};
